var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "dropdown-item nav-item w-100",
      class: { nested_aside_active: _vm.isActive() },
    },
    [
      _c(
        "router-link",
        {
          staticClass: "d-flex gap-2 align-items-center",
          attrs: {
            to: { path: _vm.link.path },
            "active-class": "",
            "exact-active-class": "",
          },
        },
        [
          _c("i", { class: _vm.link.icon }),
          _vm._v(" "),
          _c("h3", { staticClass: "aside_item fs-16px" }, [
            _vm._v(_vm._s(_vm.Lang.get(`messages.sidebar.${_vm.link.label}`))),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }